// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_zYO","cls2":"RecommendedPodcastBadge-cls2_L7g RecommendedPodcastBadge-cls1_zYO"};